import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import memoize from 'lodash/memoize';
import styles from './Catalog.scss';
import tableStyles from './elements/ModificationsTable.scss';
import * as actions from 'src/redux/catalogActions';
import Media from 'react-responsive';
import CatalogHeader from './elements/CatalogHeader.jsx';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import carImg from 'src/imgs/car/default-car.jpg';
import {getIdByURL} from 'src/logic/utils';
import {isDesktop} from 'src/logic/utils';
import {filter, map} from 'lodash';
import {Link} from 'react-router';
import config from 'src/config';
import CartComponent from 'src/components/Cart/CartComponent';
import { browserHistory } from 'react-router';

const renderTableHeader = memoize(() => (
    <Thead>
      <Th column="Номер">
        Номер
      </Th>
      <Th column="Описание детали">
        Описание детали
      </Th>
      <Th column="Кол-во, шт.">
        Кол-во, шт.
      </Th>
      {/*<Th column="Цена">
        Цена, <span className="price">&#8381;</span>
      </Th>
     <Th column=" " />
      <Th column="предложения">{' '}</Th>*/}
    </Thead>
  ));

export class ComponentList extends Component {
  constructor(props, context) {
    super(props, context);
    const modificationId = getIdByURL();
    props.getMaintenanceDetails(modificationId);

  }

  render() {
    console.log(this.props);
    const maintenanceDetailList = this.props.maintenanceDetailList;
    const tableRows = map(maintenanceDetailList, (item, i) => {
      return (
        <Tr>
          <Td column="Номер">
            <Link
              to={`/search?article=${item.article}`}
              key={`article_${i}`}
              className="link"
              onClick={() => browserHistory.push({pathname: '/search', query: { article: item.article}})}>
              {item.article}
            </Link>
          </Td>
          <Td column="Описание детали" style={{width:'70%'}}>
            <Link
              to={`/search?article=${item.article}`}
              key={`article_${i}`}
              className="link"
              onClick={() => browserHistory.push({pathname: '/search', query: { article: item.article}})}>
              {item.name}
            </Link>
          </Td>
          <Td column="Кол-во, шт.">
            {item.quantity}
          </Td>
          {/*<Td column="Цена" style={{fontSize:'1.1rem'}}>
            <strong>123</strong>
          </Td>

          <Td column=" ">
            <CartComponent colored />
          </Td>
          <Td column="предложения">
            <Link
              to={`/search?article=${item.detailNum}`}
              key={`detailNum_${i}`}
              className="link"
              onClick={() => browserHistory.push({pathname: '/results', query: { detailNum: item.detailNum}})}>
              Еще 18 предложений
            </Link>
          </Td>*/}
        </Tr>
      );
    });

    const table = (
      <Table className={tableStyles.table}>
        {renderTableHeader()}
        {tableRows}
      </Table>
    );

    return (
        <div className={styles.Catalog}>
          <Media query="(min-width: 1025px)">
            <CatalogHeader
              whatIsIt="Список запчастей для ТО"
              showFilter={false}
              routes={this.props.routes}
            />
            <div className={styles.model_container}>
              <img className={styles.responsive_img} src={this.props.model.imgUrl} onError={(e)=> e.target.src = carImg}/>
              <div className={styles.car_info}>
                <span><a href="#" className="link">{this.props.brand && this.props.brand.brandName } {this.props.model.modelName}</a></span>
                <h5 className={styles.car_year}>{this.props.model.modelYearStart+' - '}{this.props.model.modelYearEnd?(this.props.model.modelYearEnd):'наст. время'}</h5>
              </div>
            </div>
            {table}
          </Media>
          <Media query="(max-width: 1024px)">
            <h3 style={{width: '100%', marginBottom: '1rem',marginLeft: '1rem'}}>
              Список запчастей для ТО
            </h3>
            <div className={styles.model_container} style={{marginLeft: '1rem'}}>
              <img className={styles.responsive_img} src={carImg}/>
              <div className={styles.car_info} style={{marginLeft: '0'}}>
                <span><a href="#" className="link">Lexus Model SC BP-44 (EWA17)</a></span>
                <h5 className={styles.car_year}>2001 - настю время, 220D</h5>
              </div>
            </div>
            <div className={styles.mod_table_container}>
              {table}
            </div>
          </Media>
        </div>
    );
  }
}

ComponentList.routeTitle = "Список запчастей для ТО";


export default connect(
  (state) => ({...state.catalogReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(ComponentList);



/** WEBPACK FOOTER **
 ** ./src/components/Catalog/ComponentList.jsx
 **/